export default "__VITE_ASSET__C9oYkRtn__"